import { Reveal } from "./Reveal";

const INCLUDED = [
  "12 weekly 1:1 sessions (2 hours each)",
  "A personalised programme tailored to your unique awakening and integration process",
  "Somatic movement and body-awareness practices",
  "Kundalini Yoga, meditation, and breathwork techniques",
  "Guided meditations and integration practices",
  "Nervous system regulation tools for everyday life",
  "Emotional processing and embodied self-inquiry",
  "Intuitive guidance where appropriate",
  "Grounding rituals and elemental practices to support embodiment",
  "A comprehensive integration workbook with practices, tools, and reflective exercises",
  "Ongoing support between sessions for guidance, accountability, and integration",
  "Continued integration support to help you embody lasting change beyond the journey",
  "A safe, compassionate, and confidential space where your awakening can unfold with care",
];

export const Included = () => (
  <section
    data-testid="included-section"
    className="px-6 md:px-12 py-28 md:py-40"
  >
    <div className="max-w-6xl mx-auto">
      <Reveal>
        <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-amethyst font-medium mb-6">
          What's Included
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-none text-soil max-w-3xl mb-16 md:mb-24">
          Held, <span className="italic text-amethyst">every step</span> of
          the way.
        </h2>
      </Reveal>
      <div className="grid md:grid-cols-2 gap-x-16">
        {INCLUDED.map((item, i) => (
          <Reveal key={item} delay={0.04 * i} y={20}>
            <div
              data-testid={`included-item-${i + 1}`}
              className="flex items-start gap-5 py-5 border-t border-soil/15"
            >
              <span className="font-serif italic text-amethyst/70 text-sm w-8 shrink-0 pt-1">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="text-sm md:text-base text-clay leading-relaxed">
                {item}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
